<template>
    <div class="m-c-map">
        <div class="m-c-map__inner">
            <l-map
                ref="map"
                style="height: 640px; width: 100%"
                :zoom="mapConfig.ZOOM"
                :minZoom="mapConfig.MIN_ZOOM"
                :maxZoom="mapConfig.MAX_ZOOM"
                :center="mapConfig.CENTER"
            >
                <l-tile-layer
                    :url="mapConfig.URL"
                    :attribution="mapConfig.ATTRIBUTION"
                ></l-tile-layer>
                <!-- popup for projects -->
                <l-layer-group :itemData="itemData" ref="markerPopup">
                    <l-popup>
                        {{ $t.message("project") }}: {{ itemData.title }}<br />
                        {{ $t.message("topic") }}: {{ currentTopics }}<br />
                        {{ $t.message("status") }}:
                        {{ formatStatus(itemData.status) }}<br />
                        <p>
                            <a
                                :href="`${
                                    getItemSingleBaseUrl() + itemData.url
                                }`"
                                class="c-link"
                            >
                                <span>{{
                                    $t.message("linkToProjectPage")
                                }}</span>
                                <span class="m-u-accessibility">{{
                                    itemData.title
                                }}</span>
                            </a>
                        </p>
                    </l-popup>
                </l-layer-group>
                <!-- marker cluster -->
                <v-marker-cluster ref="item.title" :options="clusterOptions">
                    <template v-for="item in filteredItems">
                        <!-- single marker -->
                        <l-marker
                            :item="item"
                            v-for="country in item.countries"
                            :key="`marker-${item.id}-${country.id}`"
                            :lat-lng="[country.lat, country.lng]"
                            @click="
                                openMarkerPopup(item.id, [
                                    country.lat,
                                    country.lng,
                                ])
                            "
                            :icon="getIcon()"
                        >
                        </l-marker>
                    </template>
                </v-marker-cluster>
                <l-geo-json
                    v-if="geoJSON"
                    :geojson="geoJSON"
                    :options="options"
                    :options-style="styleFunction"
                >
                </l-geo-json>
            </l-map>
        </div>
    </div>
</template>

<script>
import Map from "./component.map";
import Mixins from "./component.mixins";

export default {
    name: "Map",
    extends: Map,
    mixins: [Mixins],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
